import React from "react";
import { Tab } from "@headlessui/react";
import { twClassNames } from "../../helpers/twClassNames";

// Re-exported to prevent dual instance headlessui
export { Tab };

export const RfTab = ({
    className,
    children,
    dark,
    static: isStatic,
    ref,
    ...props
}: Omit<React.ComponentProps<"button">, "children" | "className"> & {
    children: (({ selected }) => JSX.Element) | React.ReactNode;
    className?: string | (({ selected }) => string);
    dark?: boolean;
    static?: boolean;
}) => (
    <Tab
        className={({ selected }) =>
            twClassNames(
                selected
                    ? dark
                        ? "border-aquavision-500 font-medium text-aquavision-500"
                        : "border-brand font-medium text-brand"
                    : dark
                      ? "border-transparent text-gray-400 hover:border-gray-700 hover:bg-gray-800 hover:text-gray-200"
                      : "border-transparent text-gray-500 hover:border-gray-200 hover:bg-gray-50 hover:text-gray-700",
                "flex items-center gap-2 border-b-2 px-4 py-2 text-left text-sm transition duration-200 focus:outline-none focus-visible:outline-none focus-visible:ring-0",
                isStatic
                    ? "cursor-default"
                    : "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
                dark ? "focus-visible:ring-aquavision-300" : "focus-visible:ring-brand",
                className
            )
        }
        style={{ fontFamily: "Inter" }}
        disabled={isStatic}
        {...props}
    >
        {children}
    </Tab>
);

export const RfSideTab = ({
    className,
    children,
    static: isStatic,
    ref,
    ...props
}: Omit<React.ComponentProps<"button">, "children" | "className"> & {
    children: (({ selected }) => JSX.Element) | React.ReactNode;
    className?: string | (({ selected }) => string);
    static?: boolean;
}) => (
    <Tab
        className={({ selected }) =>
            twClassNames(
                selected
                    ? "bg-purple-100 font-medium text-purple-600"
                    : "font-normal text-tertiary hover:bg-gray-50 hover:text-secondary",
                "flex items-center gap-2 rounded-lg px-3 py-2 text-left font-sans text-sm transition duration-200 focus:outline-none focus-visible:outline-none focus-visible:ring-0",
                isStatic
                    ? "cursor-default"
                    : "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
                className
            )
        }
        disabled={isStatic}
        {...props}
    >
        {children}
    </Tab>
);
